import React from 'react';
import styled from 'styled-components';

const EmbedContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
`;

const StyledIframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
`;

interface MediaEmbedProps {
  embedUrl: string;
}

const MediaEmbed: React.FC<MediaEmbedProps> = ({ embedUrl }) => {
  return (
    <EmbedContainer>
      <StyledIframe
        src={embedUrl}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded content"
      />
    </EmbedContainer>
  );
};

export default MediaEmbed;
